export default "__VITE_ASSET__mMZbyTNv__"